import React from 'react';
import { Card } from 'react-bootstrap';
import './FontesPesquisa.css';

const FontesPesquisa = () => {
  return (
    <Card>

      <div className="fontes-container">
        <h1 className="fontes-titulo">Fontes de Pesquisa</h1>
        <p className="fontes-paragrafo">
          Para esta palestra, utilizamos várias fontes confiáveis para fornecer informações atualizadas e precisas sobre tecnologias de rede Wi-Fi, incluindo Wi-Fi 6, Wi-Fi 6E e Wi-Fi 7. Abaixo estão as principais fontes de pesquisa utilizadas:
        </p>
        <div className="fonte-item">
          <h2 className="fonte-nome">Wi-Fi Alliance:</h2>
          <p className="fonte-descricao">
            "Wi-Fi CERTIFIED 7™ Marks the Emergence of the Latest Generation of Wi-Fi" - Artigo detalhando as características e benefícios do Wi-Fi 7.
            <br />
            Disponível em: <a href="https://www.wi-fi.org/" className="fonte-link" target="_blank" rel="noopener noreferrer">Wi-Fi Alliance</a>
          </p>
        </div>
        <div className="fonte-item">
          <h2 className="fonte-nome">Tech:</h2>
          <p className="fonte-descricao">
            "Wi-Fi 7: Everything You Need to Know About the New Wireless Standard" - Informações sobre o lançamento, características e especificações do Wi-Fi 7.
            <br />
            Disponível em: <a href="https://www.techradar.com/" className="fonte-link" target="_blank" rel="noopener noreferrer">Tech</a>
          </p>
        </div>
        <div className="fonte-item">
          <h2 className="fonte-nome">9to5Mac:</h2>
          <p className="fonte-descricao">
            "Wi-Fi 7 Officially Launches – Here's What It Means for Future Apple Devices" - Discussão sobre o impacto do Wi-Fi 7 em dispositivos futuros e comparações com Wi-Fi 6E.
            <br />
            Disponível em: <a href="https://www.9to5mac.com/" className="fonte-link" target="_blank" rel="noopener noreferrer">9to5Mac</a>
          </p>
        </div>
        <div className="fonte-item">
          <h2 className="fonte-nome">Cisco:</h2>
          <p className="fonte-descricao">
            "Wi-Fi 6: The Next Generation of Wireless Technology" - Artigo explicando as melhorias e funcionalidades do Wi-Fi 6.
            <br />
            Disponível em: <a href="https://www.cisco.com/" className="fonte-link" target="_blank" rel="noopener noreferrer">Cisco</a>
          </p>
        </div>
        <p className="fontes-paragrafo">
          Estas fontes forneceram uma base sólida para discutir as tecnologias de rede sem fio mais recentes, seus benefícios e desafios, e as melhores práticas para configuração e manutenção de redes Wi-Fi.
        </p>
      </div>
    </Card>
  );
};

export default FontesPesquisa;
